import differenceInDays from 'date-fns/differenceInDays'

import { TriageSearch } from '../../../models'
import { LYRA_ESSENTIALS_BENEFIT } from '../types'

export const shouldOpenBenefitInCurrentTab = (benefitName?: string) => {
  const benefitsThatShouldOpenInCurrentTab = [LYRA_ESSENTIALS_BENEFIT]
  return benefitsThatShouldOpenInCurrentTab.includes(benefitName ?? '')
}

export const isLastTriageSearchGreaterThanSevenDays = (triageSearch: TriageSearch[]) => {
  if (triageSearch && triageSearch.length > 0) {
    const latestTriageSearch = triageSearch[0]
    const latestUpdateDate = latestTriageSearch.update_date
    if (latestUpdateDate) {
      const updateDate = new Date(latestUpdateDate)
      return differenceInDays(new Date(), updateDate) >= 7
    }
  }

  return false
}
